// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"033c80b6","159":"f7f2b62f","348":"2521cd31","641":"89588ffb"}[chunkId] + ".chunk.js";
};